import React, { useEffect } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { setTitle } from 'redux/slices/uiSlice';
import { useDispatch, useSelector } from 'react-redux';
import { CustomTab } from 'components';
import { Box, Grid } from '@mui/material';

const ErrorCodesTabScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { current } = useSelector(store => store.providers)

  useEffect(() => {
    dispatch(setTitle('Homologación Errores Proveedor'));
    // eslint-disable-next-line
  }, [])

  return (
    <Box mt={-2}>
      <CustomTab
        panels={[
          {
            name: "Homologados",
            route: '/admin/homologacion/errorcodes/homologados',
            onChange: () => navigate('homologados'),
            content: <Outlet />
          },
          {
            name: "Recibidos",
            route: '/admin/homologacion/errorcodes/recibidos',
            onChange: () => navigate('recibidos'),
            content: <Outlet />
          },
          {
            name: "Respaldo",
            route: '/admin/homologacion/errorcodes/respaldo',
            onChange: () => navigate('respaldo'),
            content: <Outlet />
          },
        ].filter(Boolean)}
      />
    </Box>
  );
}

export default ErrorCodesTabScreen